(ns lemonpi.ads-schema.tiktok)

;; extracted from https://business-api.tiktok.com/portal/docs?id=1737174886619138

(def cta-options
  [{:key "APPLY_NOW" :label "Apply now"}
   {:key "BOOK_NOW" :label "Book now"}
   {:key "CALL_NOW" :label "Call now"}
   {:key "CHECK_AVAILABLILITY" :label "Check availability"}
   {:key "CONTACT_US" :label "Contact us"}
   {:key "DOWNLOAD_NOW" :label "Download"}
   {:key "EXPERIENCE_NOW" :label "Experience now"}
   {:key "GET_QUOTE" :label "Get quote"}
   {:key "GET_SHOWTIMES" :label "Get showtimes"}
   {:key "GET_TICKETS_NOW" :label "Get tickets now"}
   {:key "INSTALL_NOW" :label "Install now"}
   {:key "INTERESTED" :label "Interested"}
   {:key "LEARN_MORE" :label "Learn more"}
   {:key "LISTEN_NOW" :label "Listen now"}
   {:key "ORDER_NOW" :label "Order now"}
   {:key "PLAY_GAME" :label "Play game"}
   {:key "PREORDER_NOW" :label "Pre-order now"}
   {:key "READ_MORE" :label "Read more"}
   {:key "SEND_MESSAGE" :label "Send message"}
   {:key "SHOP_NOW" :label "Shop now"}
   {:key "SIGN_UP" :label "Sign up"}
   {:key "SUBSCRIBE" :label "Subscribe"}
   {:key "VIEW_NOW" :label "View now"}
   {:key "VIEW_PROFILE" :label "View profile (Only supported in ads with the advertising objective ENGAGEMENT)"}
   {:key "VISIT_STORE" :label "Visit store"}
   {:key "WATCH_LIVE" :label "Watch LIVE (Only supported in LIVE ads)"}
   {:key "WATCH_NOW" :label "Watch now"}
   {:key "JOIN_THIS_HASHTAG" :label "Join this hashtag (Only supported in R&F ads)"}
   {:key "SHOOT_WITH_THIS_EFFECT" :label "Shoot with this effect (Only supported in R&F ads)"}
   {:key "VIEW_VIDEO_WITH_THIS_EFFECT" :label "View video with this effect (Only supported in R&F ads)"}])

(def cta-keys (mapv :key cta-options))
